import { render } from "./MixedMediaPopUp.vue?vue&type=template&id=045ad068&scoped=true&ts=true"
import script from "./MixedMediaPopUp.vue?vue&type=script&lang=ts"
export * from "./MixedMediaPopUp.vue?vue&type=script&lang=ts"

import "./MixedMediaPopUp.vue?vue&type=style&index=0&id=045ad068&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045ad068"]])

export default __exports__